import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

import { Dimensions } from 'components';
import { DimensionsProvider } from 'providers';
import { isEmbed, getEmbed, getPhoto, getProviderName, isUrl } from 'features/content/helpers';
import { ExternalLink, Image, Photo } from 'features/content/widgets';
import { useContent } from 'hooks';

const useStyles = makeStyles((theme: Theme) => ({
  body: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  break: theme.mixins.breakWord,
}));

const Preview = () => {
  const classes = useStyles();
  const content = useContent();

  const { content_object } = content;

  function renderEmbed() {
    return <Fragment>{getEmbed(content)}</Fragment>;
  }

  function renderPhoto() {
    const photo = getPhoto(content);

    return (
      <Dimensions>
        {dimensions => (
          <DimensionsProvider value={dimensions}>
            {photo ? <Photo photo={photo} /> : <Image content={content} />}
          </DimensionsProvider>
        )}
      </Dimensions>
    );
  }

  function renderUrl() {
    const { url_metadata } = content_object;

    const providerName = getProviderName(content);

    return (
      <ExternalLink>
        <Card>
          {renderPhoto()}
          <CardContent>
            <Typography variant="body2" className={classNames(classes.body, classes.break)}>
              {url_metadata.title}
            </Typography>
            <Typography className={classes.break}>{providerName}</Typography>
          </CardContent>
        </Card>
      </ExternalLink>
    );
  }

  if (isEmbed(content)) {
    return renderEmbed();
  } else if (isUrl(content)) {
    return renderUrl();
  }

  return renderPhoto();
};

export default Preview;
